/*
 * Desenho do preview de bordado sobre a foto — ADR-0017.
 *
 * Recebe o contexto 2D por argumento em vez de procurar um canvas: é o que
 * permite testar a posição do texto sem navegador, e é onde erra caro.
 *
 * Não desenha a foto. Quem chama já pintou a foto no canvas; aqui entra só a
 * camada de texto, por cima.
 */

(function (window) {
  'use strict';

  /**
   * Pinta os blocos do bordado na área calibrada.
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {{area, largura, altura, blocos: {linhas: string[], tamanho: number}[], cor, familia}} opcoes
   * @returns {{linhas: number, estourou: boolean}}
   */
  function desenhar(ctx, { area, largura, altura, blocos, cor, familia }) {
    // Cada bloco traz o próprio corpo; aqui vira uma pilha de linhas.
    const linhas = (blocos ?? []).flatMap((bloco) => bloco.linhas.map((texto) => ({ texto, tamanho: bloco.tamanho })));
    if (linhas.length === 0) return { linhas: 0, estourou: false };

    const p = window.FoxTheme.bordadoGeometria.areaEmPixels(area, largura, altura);

    // Cada linha desce pela média do corpo dela e da anterior, vezes o gap —
    // a entrelinha da POC, que aguenta corpos diferentes na mesma pilha.
    let y = 0;
    const alturas = linhas.map((linha, indice) => {
      if (indice > 0) y += ((linhas[indice - 1].tamanho + linha.tamanho) / 2) * p.gap;
      return y;
    });
    // Pilha centrada verticalmente na âncora, para que acrescentar a segunda
    // linha não empurre a primeira para fora da faixa bordável.
    const inicio = -alturas[alturas.length - 1] / 2;

    ctx.save();
    ctx.translate(p.x, p.y);
    ctx.rotate((p.rot * Math.PI) / 180);
    // Inclinação acompanha o caimento do tecido. Os eixos entram como cisalha,
    // não como rotação: o texto deforma junto com a dobra em vez de só girar.
    ctx.transform(1, p.sky, p.skx, 1, 0, 0);

    ctx.fillStyle = cor;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    let estourou = false;
    linhas.forEach((linha, indice) => {
      ctx.font = `${linha.tamanho}px "${familia}"`;
      if (ctx.measureText(linha.texto).width > p.max) estourou = true;
      ctx.fillText(linha.texto, 0, inicio + alturas[indice]);
    });

    ctx.restore();

    return { linhas: linhas.length, estourou };
  }

  /**
   * Pinta o PNG do ícone na posição calibrada (ENN-95). Como `desenhar`, não
   * pinta a foto: quem chama já a pôs no canvas.
   *
   * O relevo é o mesmo truque leve do texto: uma cópia 1 px abaixo em
   * `multiply`, quase transparente, antes do ícone.
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {{icone: {x, y, rot, tamanho}, largura: number, altura: number, imagem: CanvasImageSource & {naturalWidth?: number, naturalHeight?: number, width?: number, height?: number}}} opcoes
   * @returns {{x: number, y: number, rot: number, largura: number, altura: number}|null}
   */
  function desenharIcone(ctx, { icone, largura, altura, imagem }) {
    if (!icone || !imagem) return null;

    const larguraPng = imagem.naturalWidth || imagem.width || 0;
    const alturaPng = imagem.naturalHeight || imagem.height || 0;
    const proporcao = larguraPng > 0 ? alturaPng / larguraPng : 1;
    const p = window.FoxTheme.bordadoGeometria.iconeEmPixels(icone, largura, altura, proporcao);

    ctx.save();
    ctx.translate(p.x, p.y);
    ctx.rotate((p.rot * Math.PI) / 180);

    ctx.save();
    ctx.globalCompositeOperation = 'multiply';
    ctx.globalAlpha = 0.25;
    ctx.drawImage(imagem, -p.largura / 2, -p.altura / 2 + 1, p.largura, p.altura);
    ctx.restore();

    ctx.drawImage(imagem, -p.largura / 2, -p.altura / 2, p.largura, p.altura);
    ctx.restore();

    return p;
  }

  window.FoxTheme = window.FoxTheme || {};
  window.FoxTheme.bordadoRender = { desenhar, desenharIcone };
})(window);
